<template>
    <div class="fileUpload">
        <el-upload
            ref="upload"
            :file-list="fileList"
            :limit="limit"
            :on-exceed="handleExceed"
            :before-remove="beforeRemove"
            :auto-upload="autoUpload"
            :before-upload="beforeUpload"
            :http-request="httpRequest"
            accept=".doc,.docx,.pdf"
        >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
                * 只能上传Word、PDF文件，且不超过2M
            </div>
        </el-upload>
    </div>
</template>
<script>
import * as publicApi from "@/http/publicApi.js";
export default {
    props: {
        autoUpload: {
            type: Boolean,
            default: true,
        },
        limit: {
            type: Number,
            default: 1,
        },
        size: {
            type: Number,
            default: 2,
        },
        file: {
            type: Array,
            default: () => [],
        },
        handleAnimate: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "简历",
        },
    },
    data() {
        return {
            fileList: [
                /* {
                    name: "food.jpeg",
                    url:
                        "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
                }, */
            ],
            filePath: "",
        };
    },
    methods: {
        handleExceed(files, fileList) {
            this.$message.warning( "只能上传一份" + this.type);
        },
        beforeRemove(file, fileList) {
            //console.log(file);
            if (file && file.status == "success") {
                publicApi
                    .delFile(
                        {
                            image_url: this.filePath,
                        },
                        "post"
                    )
                    .then((res) => {
                        if (res.code == 200) {
                            //console.log(res);
                            this.$message.success("删除成功!");
                            this.$emit("fileUploaded", "");
                        } else {
                            return false;
                        }
                    })
                    .catch((err) => {
                        return false;
                    });
            }
        },
        beforeUpload(file) {
            var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
            const extension = testmsg === "docx" || testmsg === "doc" || testmsg === "pdf";
            const isLt2M = file.size / 1024 / 1024 < this.size; //这里做文件大小限制
            if (!extension) {
                this.$message.warning("上传文件只能是 Word、PDF文件!");
                return false;
            }
            if (!isLt2M) {
                this.$message.warning(`上传文件大小不能超过 ${this.size} MB!`);
                return false;
            }
            return extension && isLt2M;
        },
        httpRequest(file) {
            let formData = new FormData();
            formData.append("files", file.file);
            const loading = this.$loading({
                lock: true,
                text: "正在上传中...",
                spinner: "el-icon-loading",
                background: "rgba(255, 255, 255, 0.5)",
            });
            publicApi.uploadFile(formData, "post").then((res) => {
                if (res.code == 200) {
                    //console.log(res);
                    this.$message.success("上传成功!");
                    this.filePath = res.data;
                    this.$emit("fileUploaded", this.filePath);
                }
                loading.close();
            });
        },
        clearFiles() {
            this.$refs.upload.clearFiles();
        },
    },
    watch: {
        file: {
            handler(newVal) {
                //console.log(newVal);
                this.fileList = newVal;
                this.filePath = newVal[0].url;
            },
        },
        handleAnimate: {
            handler(newVal) {
                //console.log("handleAnimate",newVal);
                if (!newVal) {
                    // 处理上传组件文件回显的多余动画
                    this.fileList = [];
                }
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.fileUpload {
    text-align: left;
}
</style>